export function zeroFreeDecimalNumber(weight) {
  return weight % 1 === 0 ? Math.trunc(weight) : weight;
}

export const cutDigitFromRight = (price, digits) => {
  digits = Number(digits);
  if (typeof price !== 'number' || isNaN(price) || price <= 0) {
    return '0';
  }
  if (typeof digits !== 'number' || isNaN(digits) || digits < 0) {
    console.error(`Invalid digits for cutDigitFromRight: digits=${digits}`);
    return price.toString();
  }

  const priceDigits = Math.floor(Math.log10(Math.abs(price))) + 1;

  const factor = Math.pow(10, digits);
  const result = Math.floor(price / factor) * factor;

  return result.toString();
};

export function isNumeric(value) {
  if (typeof value === 'string') {
    // Remove commas from strings like '44,555,000'
    const cleaned = value.replace(/,/g, '');
    return !isNaN(cleaned) && !isNaN(parseFloat(cleaned));
  }
  return !isNaN(value) && !isNaN(parseFloat(value));
}
